import { Injectable, inject } from '@angular/core';
import { AuthenticationHttpClient } from '@core/services/http/authentication-http-client';

@Injectable({
  providedIn: 'root',
})
export class AddUserFromKeycloakService {
  private readonly authenticationHttpClient = inject(AuthenticationHttpClient);

  addUserFromKeycloak() {
    this.authenticationHttpClient.addUserFromKeycloak();
  }
}
